import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { createImmutableObjectClass } from 'immutable-less';
import { cleanObject } from 'marketplace-ui-common/utils/formatters';
import Screenshot from 'marketplace-ui-common/records/Screenshot';
import SocialScreenshots from 'marketplace-ui-common/records/SocialScreenshots';
import { baseOffering } from '../types/BaseOffering';
import { getHasAppCertificationCredential } from '../../common/utils/Certification';
import DataSync from './DataSync';
const ListingViewDefaults = {
  agencyPricingUrl: undefined,
  appIntegrations: [],
  appLanguages: [],
  appUrl: '',
  benefits: '',
  casesUrl: undefined,
  categoryV2: [],
  chatUrl: undefined,
  companyName: '',
  companyUrl: undefined,
  currency: 'USD',
  dataSyncHowItWorks: undefined,
  dataSyncInfo: undefined,
  dataSyncs: [],
  email: '',
  facebookUrl: undefined,
  features: [],
  forumUrl: undefined,
  hubSpotFeatures: [],
  iconUrl: '',
  id: 0,
  interactionDetails: undefined,
  integrationFeatures: [],
  keywords: [],
  language: undefined,
  name: '',
  neededScopeGroups: [],
  offering: baseOffering,
  offeringId: 0,
  opsHub: false,
  phone: undefined,
  pricingUrl: undefined,
  pricings: [],
  privacy2Url: undefined,
  privacy3Url: undefined,
  privacyUrl: '',
  queueDepth: undefined,
  reviewNotes: undefined,
  screenshots: [],
  setupUrl: '',
  socialScreenshots: new SocialScreenshots(),
  supportLanguages: [],
  supportUrl: undefined,
  tagline: '',
  termsUrl: '',
  thumbnailUrl: undefined,
  tiers: [],
  updatedAt: undefined,
  videoUrl: undefined
};
export default class ListingView extends createImmutableObjectClass(ListingViewDefaults, {
  fromJSON: _ref => {
    let json = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
    const {
      categoryV2,
      dataSyncs,
      hubSpotFeatures,
      screenshots,
      socialScreenshots,
      tiers
    } = json;
    return cleanObject(Object.assign({}, json, {
      categoryV2: categoryV2,
      dataSyncs: dataSyncs.map(item => new DataSync(item)),
      hubSpotFeatures: hubSpotFeatures,
      screenshots: screenshots.map(item => new Screenshot(item)),
      socialScreenShots: new SocialScreenshots(socialScreenshots),
      tiers: tiers
    }));
  },
  toJSON: _ref2 => {
    let rest = Object.assign({}, (_objectDestructuringEmpty(_ref2), _ref2));
    return Object.assign({}, rest);
  }
}) {
  getSourceId() {
    return this.offering.sourceId;
  }
  getAppId() {
    const sourceId = this.getSourceId();
    return sourceId ? parseInt(sourceId, 10) : null;
  }
  getIsCertified() {
    return getHasAppCertificationCredential(this.offering.credentials);
  }
}